export const fi = {
  "Sign In": "Kirjaudu sisään",
  "Sign Up": "Rekisteröidy",
  Status: "Tila",
  Version: "Versio",
  Home: "Etusivu",
  "Dance Styles": "Tanssilajit",
  Patterns: "Kuviot",
  Routines: "Kuviosarjat",
  "Sign Out": "Kirjaudu ulos",
  Create: "Luo",
  Back: "Takaisin",
  Latin: "Latin",
  Standard: "Vakio",
  "Type to search...": "Kirjoita hakeaksesi...",
  View: "Näytä",
  Edit: "Muokkaa",
  Active: "Aktiivinen",
  Disabled: "Ei käytössä",
  "Dance Style": "Tanssilaji",
  Discipline: "Laji",
  "Privacy Policy": "Tietosuojaseloste",
  "Terms of Service": "Käyttöehdot",
  "Create Account": "Luo tili",
  "Sign In with Google": "Kirjaudu sisään Googlella",
  Username: "Käyttäjänimi",
  "Enter your Username": "Syötä käyttäjänimesi",
  Password: "Salasana",
  "Enter your Password": "Syötä salasanasi",
  "Sign in": "Kirjaudu sisään",
  "Sign Up with Google": "Rekisteröidy Googlella",
  "Confirm Password": "Vahvista salasana",
  "Please confirm your password": "Vahvista salasanasi",
  Email: "Sähköposti",
  "Enter your Email": "Syötä sähköpostiosoitteesi",
  Code: "Koodi",
  Confirm: "Vahvista",
  "Back to Sign In": "Takaisin kirjautumiseen",
  "Incorrect username or password.": "Väärä käyttäjänimi tai salasana.",
  "Add Pattern": "Lisää kuvio",
  Variations: "Variaatiot",
  "Add Variation": "Lisää variaatio",
  Rhythm: "Rytmi",
  Hold: "Ote",
  Variation: "Variaatio",
  "Add Routine": "Lisää kuviosarja",
  Name: "Nimi",
  Videos: "Videot",
  "Pattern list": "Kuviolista",
  Owners: "Omistajat",
  "Select a dance style": "Valitse tanssilaji",
  Clear: "Tyhjennä",
  Submit: "Lähetä",
  "Add item": "Lisää kohde",
  "The value is required": "Arvo vaaditaan",
  "Edit Routine": "Muokkaa kuviosarjaa",
  Reset: "Nollaa",
  Add: "Lisää",
  Cancel: "Peruuta",
  "Upload Videos": "Lataa videot",
  "Browse files": "Selaa tiedostoja",
  "Drop files here or": "Pudota tiedostot tähän tai",
  "Add Pattern to Routine": "Lisää kuvio kuviosarjaan",
  Pattern: "Kuvio",
  "Select a pattern": "Valitse kuvio",
  Next: "Seuraava",
  Previous: "Edellinen",
  "Select a variation": "Valitse variaatio",
  Order: "Järjestys",
  "https://virtualcoach.dance/en-GB/terms-condition/":
    "https://virtualcoach.dance/fi-FI/terms-condition/",
  "https://virtualcoach.dance/en-GB/privacy-policy/":
    "https://virtualcoach.dance/fi-FI/privacy-policy/",
  "Virtual Dance Coach": "Virtuaalinen tanssivalmentaja",
  Man: "Vieja",
  Lady: "Seuraaja",
};
